// extracted by mini-css-extract-plugin
module.exports = {"hero":"page-thanks-module--hero--qnB8i","title":"page-thanks-module--title--3MP1h","icon":"page-thanks-module--icon--1JzXl"};